import { render, staticRenderFns } from "./ImageWhyUsList.vue?vue&type=template&id=67c921b6&scoped=true&"
import script from "./ImageWhyUsList.vue?vue&type=script&lang=js&"
export * from "./ImageWhyUsList.vue?vue&type=script&lang=js&"
import style0 from "./ImageWhyUsList.vue?vue&type=style&index=0&id=67c921b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c921b6",
  null
  
)

export default component.exports